module.exports = __webpack_public_path__ + "static/sea_storm_giant-445606042e727a85e6696879a35a4df1.jpg";